<template>
    <div class="mui-float-card" :style="{width:this.width + 'px',height:this.height + 'px',top:this.styls2.top + 'px',left:this.styls2.left + 'px'}"
        @mouseenter="mouseEnter" @mouseleave="mouseLeave">
        <slot></slot>
    </div>
</template>

<script>
    //浮动窗
    export default {
        name: "v-float-card",
        data(){
            return {
                step:1,
                speed:10,
                xin:true,
                yin:true,
                itl:null,
                styls2:{
                    width:this.width + "px",
                    height:this.height + "px",
                    top:100,
                    left:0,
                }
            }
        },
        props:{
            width:{
                type:Number,
                default:100,
            },
            height:{
                type:Number,
                default:80,
            }
        },
        components:{},
        mounted(){
            this.styls2.left = (document.body.clientWidth||0) - this.width;
            this.itl = setInterval(this.float, this.speed);
        },
        methods:{
            mouseEnter(){
                if(this.itl){
                    clearInterval(this.itl);
                }
            },
            mouseLeave(){
                this.itl = setInterval(this.float, this.speed);
            },
            float(){
                let x=this.styls2.left;
                let y=this.styls2.top;
                let L = 0,T = 0;
                let OW = this.width; //宽
                let OH = this.height; //高
                let DW = document.body.clientWidth||0;
                let DH = document.body.clientHeight||0;

                x = x + this.step * (this.xin ? 1 : -1);
                if (x < L) {
                    this.xin = true;
                    x = L;
                }
                if (x > DW - OW - 1) {//-1为了ie
                    this.xin = false; x = DW - OW - 1
                }

                y = y + this.step * (this.yin ? 1 : -1);
                if (y > DH - OH - 1) {
                    this.yin = false;
                    y = DH - OH - 1;
                }
                if (y < T) {
                    this.yin = true;
                    y = T;
                }
                this.styls2.left = x;
                this.styls2.top = y;
            }
        }
    }
</script>

<style scoped>
    .mui-float-card{
        z-index: 999;
        position:absolute;
        display: block;
    }
</style>